import React from 'react';
import styled from 'styled-components';

function AptInfo({ aptName }) {
  return (
    <AptInfoContainer className='d-flex flex-row align-items-center pb-2'>
      <AptInfoIcon className='i-login-apt' />
      <AptInfoName className='pl-2 text-gray-800 font-weight-bold'>
        {aptName}
      </AptInfoName>
    </AptInfoContainer>
  );
}

const AptInfoContainer = styled.section``;
const AptInfoIcon = styled.i``;
const AptInfoName = styled.h3``;

export default AptInfo;
